import { createApi } from "@reduxjs/toolkit/query/react";
import type { ListAdminProductsRequest, ListAdminProductsResponse } from "../../contracts";
import { baseQueryAdminWithAuth } from "../api";
import { toDataSourceRequestString } from "@progress/kendo-data-query";

export const adminProductApi = createApi({
    reducerPath: "adminProductApi",
    baseQuery: baseQueryAdminWithAuth,
    endpoints: builder => ({
        listProducts: builder.query<ListAdminProductsResponse, ListAdminProductsRequest>({
            query: body => ({
                url: `product/list?${toDataSourceRequestString(body)}`,
                method: "POST",
                body
            })
        })
    })
});

export const {
    useListProductsQuery,
    useLazyListProductsQuery
} = adminProductApi;
